module.exports = __webpack_public_path__ + "static/media/sandeep.3dc187af.jpg";